module.exports = __webpack_public_path__ + "img/35.7a28841e.png";